import Link from "next/link";
import Input from "@/atoms/Input";
import Image from "next/image";
import { useEffect, useState } from "react";
import Tab from "./components/Tab";
import ArticleFilter from "./components/ArticleFilter";
import { getGuideCategoriesQuery } from "@/services/cms/queries";
import BlogsDesktop from "./components/BlogsDesktop";
import BlogsMobile from "./components/BlogsMobile";

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>("all");
  const [search, setSearch] = useState<string>("");
  const { data: guideCategories } = getGuideCategoriesQuery();
  const isCategoriesAvailable =
    guideCategories && guideCategories.data && guideCategories.data.length > 0;

  // Check if query params are available for category
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get("category");
    if (category) {
      setSelectedCategory(category);
    }
  }, []);

  const handleCategoryClick = (category: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set("category", category);
    window.history.replaceState({}, "", url.toString());
    setSelectedCategory(category);
  };

  return (
    <>
      <div className="bg-gradient-to-b md:bg-gradient-to-br from-navy from-70% md:from-60% to-magenta to-100% md:px-6 px-5 lg:px-11 xl:px-52 py-10 md:py-16 lg:py-20">
        <div className="flex gap-6 flex-col justify-center items-center">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-white">
              Home Buying Guides
              <p className="w-full text-xl md:text-2xl text-light-White text-center font-thin mt-3 md:mt-5 max-w-sm  md:max-w-md lg:max-w-3xl leading-normal">
                Discover a wealth of helpful knowledge and learning guides on
                our website, including expert tips for better budgeting,
                strategies for getting approved for a mortgage, practical saving
                tips and tricks, and much more to enhance your financial
                well-being.
              </p>
            </h1>
          </div>

          <div className="w-full flex flex-col lg:flex-row justify-between gap-5 mt-6">
            {/* Desktop View */}
            <div className="hidden lg:flex flex-col md:flex-row gap-5 mt-2">
              <Link href={`?category=all`} passHref>
                <a>
                  <Tab
                    value="all"
                    title="ALL ARTICLES"
                    active={selectedCategory === "all"}
                    onClick={() => handleCategoryClick("all")}
                  />
                </a>
              </Link>
              {isCategoriesAvailable && (
                <>
                  {guideCategories?.data.map((category, index) => (
                    <Link
                      href={`?category=${category.attributes.slug}`}
                      passHref
                      key={index}
                    >
                      <a>
                        <Tab
                          value={category.attributes.slug}
                          title={category.attributes.name}
                          active={selectedCategory === category.attributes.slug}
                          onClick={() =>
                            handleCategoryClick(category.attributes.slug)
                          }
                        />
                      </a>
                    </Link>
                  ))}
                </>
              )}
            </div>

            {/* Mobile View */}
            {isCategoriesAvailable && (
              <ArticleFilter
                categories={guideCategories.data}
                setSelectedCategory={setSelectedCategory}
              />
            )}

            {/* Search box */}
            <div className="relative w-full lg:w-auto">
              <Input
                type="text"
                placeholder="Search"
                className="bg-violetBlue rounded-full placeholder-light-white text-white w-full lg:w-96 h-14 border-none bg-opacity-25"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="absolute right-5 top-4">
                <Image
                  src="/koach/icons/search.svg"
                  width={24}
                  height={24}
                  alt="search"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Blogs */}
      <BlogsDesktop selectedCategory={selectedCategory} search={search} />
      <BlogsMobile selectedCategory={selectedCategory} search={search} />
    </>
  );
};

export default Blog;
